import { render, staticRenderFns } from "./SeriesSection.vue?vue&type=template&id=f40724ba&scoped=true&"
import script from "./SeriesSection.vue?vue&type=script&lang=js&"
export * from "./SeriesSection.vue?vue&type=script&lang=js&"
import style0 from "./SeriesSection.vue?vue&type=style&index=0&id=f40724ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40724ba",
  null
  
)

export default component.exports